import React, { useCallback, useRef } from "react"
import Item from "./Item"

const StoreList = React.memo(function StoreList({
  storeList,
  setSelectedStore,
  selectedStore,
  error,
}) {
  const { phrases } = window
  const listRef = useRef(null)

  const handleStoreSelect = useCallback(
    (storeId) => {
      setSelectedStore(storeId)
    },
    [setSelectedStore],
  )

  // Event delegation handler - single listener for all items
  const handleListClick = useCallback(
    (e) => {
      const storeCard = e.target.closest("[data-store-id]")
      if (!storeCard) return

      const storeId = storeCard.getAttribute("data-store-id")
      if (storeId && storeId !== selectedStore) {
        handleStoreSelect(storeId)
      }
    },
    [selectedStore, handleStoreSelect],
  )

  if (storeList.length === 0) {
    return (
      <div className="">
        <p className="no-stores-message">
          {error || phrases?.shops?.["no_found"] || "Not found"}
        </p>
      </div>
    )
  }

  return (
    <ul ref={listRef} className="" onClick={handleListClick} role="listbox">
      {storeList.map(
        (store, index) =>
          store.identifier && (
            <Item
              listIndex={index}
              key={store.identifier}
              store={store}
              isSelected={store.identifier === selectedStore}
            />
          ),
      )}
    </ul>
  )
})

export default StoreList
